"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EOSApiError = void 0;
var _index = require("./index.schema");
const parseGenericEOSError = function (response) {
  const safeResponse = _index.GenericErrorResponseSchema.safeParse(response);
  if (!safeResponse.success) return undefined;
  return {
    message: safeResponse.data.error.message,
    code: safeResponse.data.error.code,
    detail: safeResponse.data.error.detail
  };
};
class EOSApiError extends Error {
  constructor(_ref) {
    var _rest$config;
    let {
      response,
      ...rest
    } = _ref;
    super();
    this.error = rest;
    this.hasRequest = !!rest.request;
    this.message = rest.message;
    this.name = "EOSApiError";
    this.path = rest === null || rest === void 0 ? void 0 : (_rest$config = rest.config) === null || _rest$config === void 0 ? void 0 : _rest$config.url;
    if (response) {
      this.status = response === null || response === void 0 ? void 0 : response.status;
      const safeResponse = parseGenericEOSError(response.data);
      if (!safeResponse) return;
      this.message = safeResponse.detail;
      this.code = safeResponse.code;
      this.response = safeResponse;
    }
  }
}
exports.EOSApiError = EOSApiError;